import videojs from 'video.js';
import '../../../../../../../node_modules/videojs-youtube/dist/Youtube.min.js';

export default class VideoSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.video = this.root.querySelector('[data-video-js]');
        this.toggle = this.root.querySelector('[data-video-section-toggle]');

        this.play = false;
        this.instance = null;

        return true;
    }

    init() {
        this.setVideo();
        this.setToggle();
    }

    setVideo() {
        if (!this.video) return;
        this.instance = videojs(this.video);

        this.video.addEventListener('pause', this.onPause.bind(this));
        this.video.addEventListener('play', this.onPlay.bind(this));
    }

    setToggle() {
        if (!this.toggle) return;
        this.toggle.addEventListener('click', this.onToggle.bind(this));
    }

    onPlay() {
        this.play = true;
        this.togglePlayerAssets();
    }

    onPause() {
        this.play = false;
        this.togglePlayerAssets();
    }
 
    onToggle() {
        if (!this.toggle) return;
        this.play = !this.play;

        this.togglePlayerAssets();        

        this.play ? this.instance.play() : this.instance.pause();
    }

    togglePlayerAssets() {
        if (!this.toggle) return;

        const span = this.toggle.querySelector('span');
        const toggleClass = this.play ? 'pause' : 'play';
        const spanClass = this.play ? 'icon-pause' : 'icon-play-media';

        this.toggle.classList.remove(...['pause', 'play']);
        this.toggle.classList.add(toggleClass);

        if (span) {
            span.classList.remove(...['icon-play-media', 'icon-pause']);
            span.classList.add(spanClass);
        }
    }
}
